import api from 'js/api'
export const verifyAccountEmail = code => {
  return api(
    'POST',
    `v2/accounts/verify_account/${code}/`
  ).then(({ response: { token, userid } }) => ({ token, userid }))
}
